var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("\n    Let's build "),_c('strong',[_vm._v("your")]),_c('span',{staticClass:"typed-text"},[_c('strong',[_vm._v("\n        "+_vm._s(_vm.typeValue)+"\n      ")])]),_c('span',{staticClass:"blinking-cursor"},[_vm._v("|")]),_c('span',{staticClass:"cursor",class:{ typing: _vm.typeStatus }},[_vm._v(" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }